import React from "react";
import { Route } from "react-router-dom";
import RequireCapability from "../entitlements/RequireCapability";
import { CAP } from "../entitlements/capabilities";
import RoleGate from "./ui/RoleGate";
import CrmDashboard from "./pages/CrmDashboard";
import CrmClients from "./pages/CrmClients";
import CrmClientDetail from "./pages/CrmClientDetail";
import CrmForms from "./pages/CrmForms";
import CrmImport from "./pages/CrmImport";
import CrmEmailAutomation from "./pages/CrmEmailAutomation";
import CrmSequenceEditor from "./pages/CrmSequenceEditor";
import CrmPacks from "./pages/CrmPacks";
// crm-module BEGIN C3.02 (lane F5)
import CrmTeam from "./pages/CrmTeam";
// crm-module END
// crm-module BEGIN C3.02/C3.04 (lane F4)
import PromoteReturn from "./promote/PromoteReturn";
// crm-module END
// crm-module BEGIN CR-F3-1
import CrmSettings from "./pages/CrmSettings";
// crm-module END

/**
 * The CRM's child routes — ONE fragment, mounted by BOTH admin route trees under the
 * same parent line (routes/adminRoutes.jsx and tenant/TenantSite.jsx):
 *
 *   <Route path="crm" element={<RequireCapability capability={CAP.crm}><CrmShell /></RequireCapability>}>{crmRouteChildren}</Route>
 *
 * so the two hosts cannot drift. routes/__tests__/adminRouteParity.test.js reads this
 * file as text: every sidebar child (admin/layout/adminNav.js) must have its path here,
 * and a nested guard's capability must equal the capability of the longest nav entry
 * that prefixes it. Dialogs are never routes; Clients filters live in the query string.
 */
export const crmRouteChildren = (
  <>
    <Route index element={<CrmDashboard />} />
    <Route path="clients" element={<CrmClients />} />
    <Route path="clients/:clientId" element={<CrmClientDetail />} />
    <Route path="forms" element={<CrmForms />} />
    <Route path="import" element={<CrmImport />} />
    <Route path="email" element={<RequireCapability capability={CAP.automation}><RoleGate action="manageEmail"><CrmEmailAutomation /></RoleGate></RequireCapability>} />
    <Route path="email/sequences/:sequenceId" element={<RequireCapability capability={CAP.automation}><RoleGate action="manageEmail"><CrmSequenceEditor /></RoleGate></RequireCapability>} />
    <Route path="packs" element={<CrmPacks />} />
    {/* crm-module BEGIN C3.02 (lane F5) — Team is owner-only (roles.js `team`); RoleGate
        (not RequireCapability: it needs no extra plan capability beyond CAP.crm, which
        already gates the whole section) renders the "owner only" empty state for a
        helper who types the URL directly. */}
    <Route path="team" element={<RoleGate action="team"><CrmTeam /></RoleGate>} />
    {/* crm-module END */}
    {/* crm-module BEGIN C3.02/C3.04 — Promote (lane F4). Not a nav entry (no sidebar
        link points here) — it is the Stripe success/cancel landing for a promotion-run
        checkout (`billing_purchases_routes.open_promotion_checkout`'s hardcoded
        `success_url`/`cancel_url`), same precedent as `clients/:clientId` (a route with
        no direct nav child of its own). */}
    <Route path="promote" element={<PromoteReturn />} />
    {/* crm-module END */}
    {/* crm-module BEGIN CR-F3-1 — Settings is owner-only (roles.js `settings`), the same
        RoleGate treatment as Team: CAP.crm already gates the section. */}
    <Route path="settings" element={<RoleGate action="settings"><CrmSettings /></RoleGate>} />
    {/* crm-module END */}
  </>
);
